<template>
  <div class="tab-normal-pick">
    <!--<div-->
        <!--class="tab-normal-pick__previous icon-common"-->
        <!--:class="{ active : isActivePrevious }"-->
    <!--&gt;-->
      <!--<img src="@/assets/images/loto/previous.png"/>-->
    <!--</div>-->
    <!--<div-->
        <!--class="tab-normal-pick__next icon-common"-->
        <!--:class="{ active : isActiveNext }"-->
    <!--&gt;-->
      <!--<img src="@/assets/images/loto/next.png"/>-->
    <!--</div>-->
    <div class="tab-normal-pick__container">
      <div class="text-notify">
        Select 7 numbers from 1 to 28 or select Quick Pick.
      </div>
      <div class="tab-normal-pick__loto-container">
        <div
            v-for="(item, index) in lotoNumbers"
            :key="index"
        >
          <div class="table-loto">
            <div class="table-loto__title">Select your 7 number</div>
            <div class="table-loto__wrap">
              <div class="table-loto__container">
                <div
                    v-for="(loto, i) in lotoNumbers[index]"
                    :key="i"
                    class="table-loto__item"
                    @click="handlePickItem(index, i)"
                >
                  <img
                      v-if="loto.active"
                      src="@/assets/images/loto/selection-tick.png"
                  />
                  <a>{{ loto.number }}</a>
                </div>
              </div>
              <div class="table-loto__submit">
                <button @click="handleQuickPick(index)">Quick Pick</button>
                <div class="icon" @click="handleDeleteTable(index)">
                  <img src="@/assets/images/loto/delete.png"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-normal-pick__add-ticket">
        <button
          v-if="isPosDevice"
          @click="handleBackHome"
          class="btn-back-home mr-2"
        >
          Back Home
        </button>
        <button @click="handleAddTicket">+ Add another Ticket</button>
      </div>
    </div>
  </div>
</template>

<script>
// import { lotoNumbers } from '@/resources/loto'
import lottoService from '@/services/lotto.service';
export default {
  props: {
    isPosDevice: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      lotoNumbers: [],
      isActiveNext: true,
      isActivePrevious: false
    }
  },
  created() {

    const currentTickets = this.$store.state.tickets;
    let numberOfTicket = 8;
    if (currentTickets.length) {
        numberOfTicket = currentTickets.length;
    }
      this.lotoNumbers = lottoService.generateTickets(numberOfTicket);
    currentTickets.forEach((ticket, index) => {
        const main = ticket[0];
        this.lotoNumbers.forEach((item, j) => {
            if (index===j) {
                item.forEach(item => item.active = main.includes(item.number) ? true : false)
            }
        });
    });
  },
  methods: {
    handleBackHome() {
      this.$router.push({name: 'Home'});
    },

    handleQuickPick(index) {
      const numbers = Array(28).fill().map((_, index) => index + 1);
      numbers.sort(() => Math.random() - 0.5);
      const numbersRandom = numbers.slice(0, 7);
      this.lotoNumbers.forEach((item, i) => {
        if (index === i) {
          item.forEach(item => item.active = numbersRandom.includes(item.number) ? true : false)
        }
      })

      this.$store.dispatch('addOrUpdateTickets', this.lotoNumbers);

    },
    handleDeleteTable(index) {
      this.$bvModal.msgBoxConfirm('Are you sure to delete?', {title: 'Please Confirm'})
          .then(value => {
            value ? this.lotoNumbers = this.lotoNumbers.filter((_, i) => i !== index) : null
            this.$store.dispatch('addOrUpdateTickets', this.lotoNumbers);
          })
          .catch(err => {
            console.log(err);
          })
    },
    handlePickItem(indexList, indexNumber) {
      this.lotoNumbers.forEach((item, i) => {
        if (indexList === i) {
          const itemActive = item.filter(item => item.active === true);
          item.forEach((value, index) => {
            if (itemActive.length < 7 || value.active) {
              if (index === indexNumber) {
                value.active = !value.active;
              }
            }
          })
        }
      })
      this.$store.dispatch('addOrUpdateTickets', this.lotoNumbers);
    },
    handleAddTicket() {
      const newTicket = lottoService.generateTickets(1);
      this.lotoNumbers = [...this.lotoNumbers, newTicket[0]];
    }


  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .modal-title {
    color: black;
  }

  .modal-body {
    color: black
  }
}
</style>
